// AboutUsBanner.js
import React from 'react';
import "../Assets/Css/HomeCss/AboutUsBanner.css";

const AboutUsBanner = () => {
  return (
    <div className="about-banner">
      <img 
        src="/img/about-banner.jpg"
        alt="About Us Banner" 
        className="banner-image"
      />
      <div className="banner-overlay">
        <p className="banner-text">Get effective and informed second opinion from our global network of medical experts.</p>
      </div>
    </div>
  );
};

export default AboutUsBanner;
